<template>
  <div id="final-step">
    <!--WIND SURVEY ONLY-->
    <wind-survey-final :has-score="windHazard && windHazard.score.generated !== 'N/A'"
      v-if="dataSurvey === 'wind_survey' && isReady" @openModal="$_openModal()" />
    <!--WIND SURVEY ONLY-->

    <!--WATER SURVEY ONLY-->
    <div class="water-harzardzs" v-if="dataSurvey === 'water_survey' && isReady">
      <water-survey-final />
    </div>
    <!--WATER SURVEY ONLY-->

    <!--FLOOD SURVEY ONLY-->
    <div class="flood-hazardzs grey-text text-darken-3" v-if="dataSurvey === 'flood_survey' && isReady">
      <flood-survey-final />
    </div>
    <!--FLOOD SURVEY ONLY-->

    <!--SCORE CARD-->
    <div class="card hoverable" v-if="isReady">
      <div class="card-content" v-if="dataSelectedScore.generated">
        <!--Water And Wind Only-->
        <div class="center score gen-c" v-if="donotGenerate && !dataSelectedScore.selected">Select Your Expected Impact
          Level

          <button class="btn-floating transparent z-depth-0 waves-effect grey-text-text-darken-3"
            @click="$_viewDefinitions(dataSelectedScore.generated)">
            <i class="material-icons-outlined grey-text text-darken-3">help_outline</i>
          </button>
        </div>
        <p class="score gen-c" v-show="!donotGenerate"
          :class="dataSelectedScore.selected && dataSelectedScore.selected !== '' ? 'strike' : ''"
          v-if="dataSurvey !== 'flood_survey'">
          Generated Expected Impact Level:
          <span :class="scoreOverviewColorX">{{ dataImpactLevel }}</span>
          <button class="btn-floating transparent z-depth-0 waves-effect grey-text-text-darken-3"
            @click="$_viewDefinitions(dataSelectedScore.generated)">
            <i class="material-icons-outlined grey-text text-darken-3">help_outline</i>
          </button>
        </p>
        <!--Water And Wind Only-->

        <!--Selected Impact level-->
        <p class="score center" v-if="selectedLevel">
          Selected Expected Impact Level:
          <span v-if="selectedLevel" :style="[{ color: selectedLevel.backgroundColor }]">
            {{ dataSelectedScore.selected }}
          </span>
          <button class="btn-floating transparent z-depth-0 waves-effect grey-text-text-darken-3"
            @click="$_viewDefinitions(dataSelectedScore.selected)">
            <i class="material-icons-outlined grey-text text-darken-3">help_outline</i>
          </button>
        </p>
        <!--Selected Impact level-->

        <div class="selection-action">
          <!--Generated Imapact Level-->
          <div class="cs-view" v-if="(dataSurvey !== 'flood_survey') && (dataSelectedScore.generated !== 'N/A')">
            <div class="col s12" v-show="!donotGenerate">
              <button v-if="(!dataSelectedScore.selected || dataSelectedScore.selected === '')"
                @click="$_confirmSelection()" class="btn white btn-rounded indigo-text text-accent-2 waves-effect">
                CONFIRM
              </button>
            </div>
            <div class="col s12 center" style="margin: 12px 0"
              v-if="!dataSelectedScore.selected || dataSelectedScore.selected === ''">
              <b v-show="!donotGenerate">OR</b>
            </div>
          </div>
          <!--Generated Imapact Level-->
          <!-- Flood Hazard only -->

          <div class="col s12">
            <button :disabled="userRole === 'subscriber'"
              v-if="dataSelectedScore.justification && dataSelectedScore.justification !== ''" @click="() => {
                this.$emit('updateSelectedScore', {
                  selected: '',
                  justification: '',
                });
              }" class="btn btn-rounded white z-depth-0 indigo-text text- accent-2 waves-effect">CLEAR SELECTION
            </button>
            &nbsp;
            <button :disabled="userRole === 'subscriber'" @click="$_openModal()"
              v-text="dataSurvey !== 'flood_survey' ? 'UPDATE SELECTION' : 'MAKE A SELECTION'"
              class="btn btn-rounded indigo accent-2 waves-effect"></button>

          </div>
        </div>
      </div>
    </div>

    <div class="card" v-if="isReady" v-show="dataSelectedScore.justification && dataSelectedScore.justification !== ''">
      <div class="card-content">
        <div>
          <div style="font-size: 18px; margin-bottom: 12px;">
            User's Justification:
            <!--  <button class="btn-floating transparent z-depth-0 waves-effect grey-text-text-darken-3" @click="$_openModal(dataSelectedScore.selected)">
              <i class="material-icons-outlined grey-text text-darken-3">edit</i>
            </button> -->
          </div>
          <div class="description" v-html="dataSelectedScore.justification"></div>
        </div>
      </div>
      <div style="padding-top:0px;" class="card-action right-align">
        <button :disabled="userRole === 'subscriber'" @click="$_openModal(dataSelectedScore.selected)"
          class="btn-flat waves-effect transparent grey-text text-darken-3">
          EDIT JUSTIFICATION
        </button>
      </div>
    </div>

    <div class="empty-state" v-if="!isReady">
      <empty-state state-title="Expected Impact Level" data-icon="restart_alt" @action="$_toOverview()"
        :show-button="true" view-style="circleBg" :has-content="true">
        <template #header>
          <b>You need to complete the assessment first.</b> <br>
        </template>
        <template #content>
          <div class="justify-text" style="font-size:14px;">
            If you have completed the assessment and still see this screen, make sure you have checked the box at the
            bottom of each page to indicate that you have completed that segment of the assessment.
          </div>
        </template>
      </empty-state>
    </div>


    <impact-level-card v-if="cardModal.showing" :data-selected-score="dataSelectedScore"
      :data-card-info="cardModal.showing" @terminate="cardModal.showing = false" @updateJustification="$_updateScore">
    </impact-level-card>


    <div class="new-imm" v-if="showModal">
      <div class="modal modal-fixed-footer" ref="modal">
        <div class="modal-content ">
          <div class="modal-title-wrapper">
            <div class="modal-title z-depth-1">{{ currentSurvey }} Expected Impact Level Chart</div>
          </div>
          <div v-if="choice === ''" class="row flex">
            <impact-level-table :data-selected-score="dataSelectedScore" @choice="$_setNewChoice($event)"
              :impactCards="impactCards[dataSurvey]" />
          </div>
          <div v-else>
            <button @click="choice = ''" style="width:100%" class="btn-flat btn-rounded grey lighten-4 waves-effect"><i
                class="material-icons left">arrow_back</i> RETURN TO CHOICES</button>
            <div class="just-title">Justification</div>
            <span class="badge new indigo white-text accent-2" :data-badge-caption="choice"></span>
            <p>
              From your assessment, summarize the things you found that justify your selection. Include any other examples
              of features that make your home more/less resilient or vulnerable that were
              not included in the assessment.
            </p>
            <blockEditor v-if="readyToView" :content="justification" @content="justification = $event" />
            <!--  <vue-editor :editor-toolbar="toolbar" v-model="justification" /> -->
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn-flat waves-effects" @click="$_closeModal()">
            CANCEL
          </button>
          <button v-if="choice !== ''" :disabled="justification === ''" class=" btn-flat waves-effects green-text"
            @click="$_emitNewData()">
            CONFIRM
          </button>
        </div>
      </div>
    </div>

    <div class="disclaimer-note hoverable" v-if="isReady">
      <b>Disclaimer</b>:
      <span v-if="dataSurvey === 'wind_survey'">
        Estimations assume that homeowners have taken all necessary measures to secure their home for a pending hurricane,
        including boarding windows and doors where impact resistant windows/doors or hurricane shutters are not present.
        In boarding windows/doors, care should be taken to ensure all glass surfaces are fully covered. Estimations do not
        fully account for the potential impact that may result from projectiles striking windows, doors or other parts of
        the structure during a hurricane or for the domino effects that may occur, such as roof loss as a result of window
        or door loss.
        <br> <br>
      </span>
      <span>The SLDB and sponsors of this App cannot guarantee the accuracy of the Expected Impact Level for any property
        and shall not be held liable if impacts in reality are different
        from those suggested by the App. Estimations in this App are intended for educational and SLDB loan application
        purposes only.</span>
    </div>
  </div>
</template>
<script>
import impactLevelTable from "./impactLevelTable.vue";

import blockEditor from '@/components/contentEditor.component'
import windSurveyFinal from "./windSurveyFinal.vue";
import waterSurveyFinal from "./waterSurveyFinal.vue";
import floodSurveyFinal from "./floodSurveyFinal.vue";
import { VueEditor } from "vue2-editor";
import emptyState from "@/components/emptyState.component";
import ImpactLevelCard from "@/components/ImpactLevelCard/ImpactLevelCard";
import { schema } from "@/schemas/surveyFinalStep";
import { mapState } from "vuex";
import { schema as floodSchema } from "@/schemas/floodHazard";
import { schema as windSchema } from "@/schemas/windHazard";

export default {
  name: "FinalStep",
  components: {
    ImpactLevelCard,
    impactLevelTable,
    blockEditor,
    emptyState,
    windSurveyFinal,
    waterSurveyFinal,
    floodSurveyFinal,
    VueEditor,
  },
  props: {
    dataImpactLevel: {
      type: String,
      deafult: "",
    },
    dataSelectedScore: {
      type: [Object, Array, Boolean, String],
      default: () => ({}),
    },
    dataSurvey: {
      type: String,
      default: "wind_survey",
    },
  },
  data() {
    return {
      floodSchema,
      windSchema,
      toolbar: [
        ["bold", "italic", "underline"],
        [{ list: "ordered" }, { list: "bullet" }],
        [{ align: "" }, { align: "center" }, { align: "right" }, { align: "justify" }],
        [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
      ],
      justification: false,
      readyToView: false,
      choice: "",
      cardModal: {
        instance: null,
        options: {
          onCloseEnd: () => {
            this.cardModal.showing = false;
          },
        },
        showing: false,
      },
      showModal: false,
      modal: {
        instance: null,
        options: {
          onOpenStart: () => {
            this.justification = this.dataSelectedScore.justification
            console.log('s')
          },
          onOpenEnd: () => {
            this.readyToView = true
          },
          onCloseEnd: () => {
            this.choice = ""
            this.readyToView = false
          },
          endingTop: "5%",
        },
      },
      ...schema,
    };
  },
  mounted() {
    //  this.$_initCardModal();
  },
  computed: {
    ...mapState({
      windHazard: (state) => state.Surveys.windHazard,
      floodHazard: (state) => state.Surveys.floodHazard,
      waterHazard: (state) => state.Surveys.waterHazard,
      user: state => state.User.user
    }),
    userRole: {
      get() {
        return "user"
        return this.user && this.user.roles.length > 0
          ? this.user.roles[0]
          : false
      }
    },
    donotGenerate: {
      get() {
        return this.dataSurvey === 'wind_survey'
          ? this.windHazard.survey.rafters_section_no_rafters
          : ''
      }
    },
    scoreOverviewColorX() {
      switch (this.dataImpactLevel) {
        case "Minor":
          return "light-blue-text lighten-3";
        case "Moderate":
          return "amber-text lighten-2";
        case "Major":
          return "orange-text lighten-3";
        case "Extreme":
          return "red-text lighten-3";
        default:
          return "black-text";
      }
    },
    currentSurvey: {
      get() {
        return this.dataSurvey === "wind_survey" ? "Wind Hazard" : this.dataSurvey === "water_survey" ? "Water Hazard" : "";
      },
    },
    activeOption: {
      get() {
        return this.impactCards[this.dataSurvey].find((x) => x.name === this.dataImpactLevel);
      },
    },
    selectedLevel: {
      get() {
        return this.impactCards[this.dataSurvey].find((x) => x.name === this.dataSelectedScore.selected);
      },
    },
    windHazardProgressX() {
      if (this.windHazard && this.windHazard.survey !== "") {
        // Get all complete_field keys from schema
        const completeFieldKeyArray = Object.keys(windSchema).filter((key) => windSchema[key].fieldType === "complete_field");

        const currentLen = completeFieldKeyArray.filter((key) => this.windHazard.survey[key]).length;

        const answerLen = Object.values(this.windHazard.survey).filter((item) => {
          if (typeof item === "object") {
            if (item.length > 0) {
              return item;
            }
          } else {
            return item;
          }
        }).length;

        if (answerLen <= 0 && currentLen <= 0) {
          this.surveyStatus = "Not Yet Started";
          return 0;
        }

        if (answerLen > 0 && currentLen <= 0) {
          this.surveyStatus = "Incomplete";
          return 0;
        }

        this.surveyStatus = "";

        return Math.round((currentLen / completeFieldKeyArray.length) * 100);
      }
      return 0;
    },
    waterHazardProgressX() {
      if (this.waterHazard) {
        const len = 2;

        const currentLen = Object.keys(this.waterHazard.survey).filter(
          (key) => {
            if (key === "water_resiliency_complete") {
              return this.waterHazard.survey[key] //this.waterHazard.survey[key].length > 0 ? true : false;
            }
            else if (this.waterHazard.isNonStandard && key === 'manualEssential') {
              return this.waterHazard.survey[key].subTotal && parseFloat(this.waterHazard.survey[key].subTotal) > 1
            }
            else if (!this.waterHazard.isNonStandard && key === 'essential') {
              return this.waterHazard.survey[key].subTotal && parseFloat(this.waterHazard.survey[key].subTotal) > 1
            }
            /*     else if (this.waterHazard.totalWaterStorage && this.waterHazard.totalWaterStorage !== '' ) {
                  return  true
                 } */
            else {
              return false
            }


            /*  else if(key === 'nonEssential') {
                 return false
               }
                else if(key === 'water_resiliency_features') {
                 return false
               }
                else if(key === 'grandTotal') {
                 return false
               }
               else if( this.waterHazard.survey[key] && this.waterHazard.survey[key].subTotal) {
                 return true
               }
               else if(key === 'totalWaterStorage') {
                return this.waterHazard.survey[key] !== ''
               }
               else  {
                 return false
               }
    */


          }
        ).length;
        return Math.round((currentLen / len) * 100);
      }

      return 0;
    },
    floodHazardProgressX() {
      if (this.floodHazard) {
        // Get all complete_field keys from schema
        const completeFieldKeyArray = Object.keys(floodSchema).filter((key) => floodSchema[key].fieldType === "complete_field");

        const currentLen = completeFieldKeyArray.filter((key) => this.floodHazard.survey[key]).length;

        const answerLen = Object.values(this.floodHazard.survey).filter((item) => {
          if (typeof item === "object") {
            if (item.length > 0) {
              return item;
            }
          } else {
            return item;
          }
        }).length;

        if (answerLen <= 0 && currentLen <= 0) {
          this.surveyStatus = "Not Yet Started";
          return 0;
        }

        if (answerLen > 0 && currentLen <= 0) {
          this.surveyStatus = "Incomplete";
          return 0;
        }

        this.surveyStatus = "";

        return Math.round((currentLen / completeFieldKeyArray.length) * 100);
      }

      return 0;
    },
    isReady: {
      get() {
        return this.dataSurvey === "wind_survey" && this.windHazardProgressX > 95
          ? true
          : this.dataSurvey === "flood_survey" && this.floodHazardProgressX > 95
            ? true
            : this.dataSurvey === "water_survey" && this.waterHazardProgressX > 50
              ? true
              : false;
      },
    },
  },
  methods: {
    $_toOverview() {
      this.dataSurvey === 'wind_survey'
        ? this.$router.push({ name: 'WindHazardSurvey' })
        : this.dataSurvey === 'water_survey'
          ? this.$router.push({ name: 'WaterHazardSurvey' })
          : this.$router.push({ name: 'FloodHazardSurvey' })
    },
    $_viewDefinitions(e) {
      this.cardModal.showing = this.impactCards[this.dataSurvey].find((x) => x.name === e);
      /*     setTimeout(() => {
            this.$_cardModal();
          }, 300); */
    },
    $_initCardModal() {
      this.cardModal.instance = M.Modal.init(this.$refs.imodal, this.cardModal.options);
    },
    $_cardModal() {
      this.cardModal.instance.open();
    },
    $_setNewChoice(e) {
      this.choice = e;
    },
    $_confirmSelection() {
      this.$emit("updateSelectedScore", {
        selected: this.dataSelectedScore.generated,
        justification: "Confirmed Generated Impact Level",
      });
    },
    $_emitNewData() {
      this.$emit("updateSelectedScore", {
        selected: this.choice,
        justification: this.justification,
      });
      this.$_closeModal();
    },
    $_updateScore(val) {
      console.log(val)
      this.$emit("updateSelectedScore", val);
    },
    $_openModal(e) {
      this.showModal = true;
      if (e) this.choice = e;
      setTimeout(() => {
        this.modal.instance = M.Modal.init(this.$refs.modal, this.modal.options);
        this.modal.instance.open();

      }, 150);

      setTimeout(() => {
        M.updateTextFields();
      });
    },

    $_closeModal() {
      this.modal.instance.close();
      this.modal.instance.destroy();
      this.showModal = false;
    },
  },
};
</script>
<style lang="scss" scoped>
#final-step {
  padding: 0 16px;
  max-width: 768px;
  margin: auto;

  .score {
    font-size: 20px;
  }

  .card {
    .card-content {
      padding: 24px;

      p {
        margin-bottom: 12px;
      }
    }
  }
}

.step-title {
  font-size: 24px;

  i {
    line-height: 32px;
    margin-right: 8px;
  }
}

.section-just {
  font-size: 16px;
  font-weight: 500;
}

.gen-c {
  border-bottom: 1px solid #d5d5d5;
  padding: 0 0 12px 0;
  margin: 0 0 12px 0 !important;
  text-align: center;

  &.strike {
    text-decoration: line-through;
  }
}

.selection-action {
  width: 100%;
  /*  margin-top: 14px; */
  text-align: center;

  button {
    min-width: 180px;
  }
}

.new-imm {
  .modal {
    width: 96%;
    height: 90% !important;
    min-height: 95%;
    top: 0% !important;
    border-radius: 8px;
    max-width: 1024px;

    @media screen and (min-width: 768px) {
      top: 5% !important;
      min-height: 85%;
      height: 85% !important;
    }

    .modal-title-wrapper {
      position: relative;
      height: 55px;
      z-index: 9;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      margin: -24px -24px 6px !important;

      .modal-title {
        font-size: 19px;
        line-height: 25px;
        padding: 14px 13px 12px;
        position: fixed;
        width: calc(100% - 0px);
        background: #fff;
      }
    }

    .row {
      &.flex {
        display: flex;
        flex-wrap: nowrap;

        .col {
          min-width: 325px;
          width: 100%;
          margin: 0px;
          padding: 0px;

          &:first-of-type {
            .card {
              border-radius: 10px 0px 0 10px;
            }
          }

          &:last-child {
            .card {
              border-radius: 0px 10px 10px 0px;
              margin-right: 24px;
            }
          }
        }

        .card {
          height: calc(100% - 1.5rem);
          border: 1px solid #d2d2d2;
          border-radius: 0px;
          margin-left: -1px;
          box-shadow: none;

          .card-content {
            padding: 24px;
          }
        }
      }
    }
  }
}

.disclaimer-note {
  padding: 16px;
  background: #efefef;
  border-radius: 8px;
  margin: 20px 0px;
  font-style: italic;
}

.just-title {
  font-size: 20px;
  line-height: 21px;
  margin-top: 15px;
}

p {
  font-size: 15.5px;
}

.description {
  font-size: 16px;
}

a {
  cursor: pointer;
}

.desc-title {
  margin-top: 24px;
  font-size: 24px;
}

.custom-yellow {
  background: #fbd15e;
}</style>
